/* ==========================================================================
   AL SULTAN — Collection pages, Phase 5 · Stage 1
   Uses only Shopify's real data: collection links already rendered in the
   facets, Shopify's price filter, the section's own pagination URLs.
   ========================================================================== */
(function () {
  'use strict';

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v, a, b) {
    return v < a ? a : v > b ? b : v;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  /* ── Header ─────────────────────────────────────────────────────────── */

  function initHeader() {
    var banner = document.querySelector('.als-col-banner');
    if (!banner || banner.dataset.alsReady) return;
    banner.dataset.alsReady = 'true';
    if (REDUCED) return;
    document.documentElement.classList.add('als-col-ready');
    banner.style.setProperty('--alsc-in', '0');
    requestAnimationFrame(function () {
      banner.style.setProperty('--alsc-in', '1');
    });

    var img = banner.querySelector('.collection-banner__bg-image');
    if (!img) return;
    var queued = false;
    function update() {
      queued = false;
      var r = banner.getBoundingClientRect();
      if (r.bottom < 0) return;
      banner.style.setProperty('--alsc-scroll', clamp(-r.top / (r.height || 1), 0, 1).toFixed(3));
    }
    window.addEventListener(
      'scroll',
      function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(update);
      },
      { passive: true }
    );
  }

  /* ── Discovery chips ────────────────────────────────────────────────── */

  function priceRanges(max) {
    var steps = [20, 40, 80, 150, 300].filter(function (s) {
      return s < max;
    });
    if (!steps.length) return [];
    var out = [{ lte: steps[0] }];
    for (var i = 1; i < steps.length; i++) out.push({ gte: steps[i - 1], lte: steps[i] });
    out.push({ gte: steps[steps.length - 1] });
    return out.slice(0, 4);
  }

  function initDiscover(section) {
    var mount = section.querySelector('[data-als-col-discover]');
    if (!mount || mount.dataset.alsBuilt) return;

    var symbol = mount.dataset.symbol || '$';
    var lteInput = document.querySelector('input[name="filter.v.price.lte"]');
    var max = lteInput ? parseFloat(lteInput.getAttribute('max') || lteInput.getAttribute('placeholder')) : 0;

    // Real collection links rendered by the facets "Collection" group
    var seen = {};
    var links = [];
    document.querySelectorAll('.facets-container a.facets__label[href*="/collections/"], #main-collection-filters a.facets__label[href*="/collections/"]').forEach(function (a) {
      var href = a.getAttribute('href').split('?')[0];
      if (seen[href] || href === window.location.pathname) return;
      seen[href] = true;
      links.push({ href: href, label: a.textContent.replace(/\s+/g, ' ').trim() });
    });

    var ranges = max > 0 ? priceRanges(max) : [];
    if (!ranges.length && !links.length) {
      mount.hidden = true;
      return;
    }
    mount.dataset.alsBuilt = 'true';

    mount.appendChild(el('p', 'als-col-discover__label', 'Refine your search'));
    var rail = el('div', 'als-col-discover__rail');
    rail.setAttribute('role', 'group');
    rail.setAttribute('aria-label', 'Quick filters');

    if (ranges.length) {
      var priceGroup = el('div', 'als-col-discover__group');
      var params = new URLSearchParams(window.location.search);
      ranges.forEach(function (r) {
        var label =
          r.gte == null
            ? 'Under ' + symbol + r.lte
            : r.lte == null
            ? symbol + r.gte + '+'
            : symbol + r.gte + '–' + symbol + r.lte;
        var chip = el('button', 'als-chip', label);
        chip.type = 'button';
        var active =
          (params.get('filter.v.price.gte') || '') === (r.gte != null ? String(r.gte) : '') &&
          (params.get('filter.v.price.lte') || '') === (r.lte != null ? String(r.lte) : '') &&
          (params.has('filter.v.price.gte') || params.has('filter.v.price.lte'));
        chip.setAttribute('aria-pressed', active ? 'true' : 'false');
        chip.addEventListener('click', function () {
          applyPrice(r, chip.getAttribute('aria-pressed') === 'true', priceGroup, chip);
        });
        priceGroup.appendChild(chip);
      });
      rail.appendChild(priceGroup);
    }

    if (links.length) {
      var colGroup = el('div', 'als-col-discover__group');
      links.slice(0, 16).forEach(function (l) {
        var a = el('a', 'als-chip', l.label);
        a.href = l.href;
        colGroup.appendChild(a);
      });
      rail.appendChild(colGroup);
    }

    mount.appendChild(rail);
    mount.hidden = false;
  }

  function applyPrice(range, wasActive, group, chip) {
    var params = new URLSearchParams(window.location.search);
    params.delete('page');
    params.delete('filter.v.price.gte');
    params.delete('filter.v.price.lte');
    if (!wasActive) {
      if (range.gte != null) params.set('filter.v.price.gte', range.gte);
      if (range.lte != null) params.set('filter.v.price.lte', range.lte);
    }
    group.querySelectorAll('.als-chip').forEach(function (c) {
      c.setAttribute('aria-pressed', !wasActive && c === chip ? 'true' : 'false');
    });
    var query = params.toString();
    // facets.js declares FacetFiltersForm as a top-level class (not on window)
    if (typeof FacetFiltersForm !== 'undefined' && typeof FacetFiltersForm.renderPage === 'function') {
      FacetFiltersForm.renderPage(query);
    } else {
      window.location.search = query;
    }
  }

  /* ── Grid entrance ──────────────────────────────────────────────────── */

  var cardObserver = null;

  function columns(grid) {
    var cols = getComputedStyle(grid).gridTemplateColumns;
    if (cols && cols !== 'none') return cols.split(' ').length;
    var first = grid.firstElementChild;
    return first ? Math.max(1, Math.round(grid.clientWidth / first.getBoundingClientRect().width)) : 2;
  }

  function prepareCards(grid, cards) {
    // Phase 7.2: every read (column count, card positions) happens before the first write, so the
    // page is styled once here instead of twice. On the first pass `als-col-card` has no visual
    // effect yet (`als-col-motion` is added afterwards), so positions are the same either way.
    var cols = columns(grid);
    var observe = !REDUCED && 'IntersectionObserver' in window;
    var motion = document.documentElement.classList.contains('als-col-motion');
    var vh = window.innerHeight;
    var onScreen =
      observe && !motion
        ? cards.map(function (c) {
            var r = c.getBoundingClientRect();
            return r.top < vh && r.bottom > 0;
          })
        : [];
    cards.forEach(function (card, i) {
      card.classList.add('als-col-card');
      card.style.setProperty('--col', i % cols);
    });
    if (!observe) {
      cards.forEach(function (c) {
        c.classList.add('is-in');
      });
      return;
    }
    if (!cardObserver) {
      cardObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-in');
            cardObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -6% 0px', threshold: 0.08 }
      );
    }
    // Cards already on screen at load appear immediately (no blank flash).
    cards.forEach(function (c, i) {
      if (onScreen[i] && !motion) {
        c.classList.add('is-in');
      } else {
        cardObserver.observe(c);
      }
    });
  }

  /* ── Progressive loading ────────────────────────────────────────────── */

  function initMore(section) {
    var more = section.querySelector('[data-als-col-more]');
    var grid = section.querySelector('ul.product-grid');
    if (!more || !grid || more.dataset.alsReady) return;
    more.dataset.alsReady = 'true';
    section.classList.add('als-col-progressive');
    more.hidden = false;

    var label = more.querySelector('.als-col-more__label');
    if (label) label.setAttribute('aria-live', 'polite');
    var btn = more.querySelector('[data-als-col-load]');
    if (!btn) return;

    btn.addEventListener('click', function (event) {
      var next = more.dataset.next;
      if (!next || btn.getAttribute('aria-busy') === 'true') return;
      var url = new URL(next, window.location.origin);
      url.searchParams.set('section_id', grid.dataset.id);
      btn.setAttribute('aria-busy', 'true');
      var fromKeyboard = event.detail === 0;

      fetch(url.toString())
        .then(function (r) {
          if (!r.ok) throw new Error(r.status);
          return r.text();
        })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var incoming = Array.prototype.slice.call(doc.querySelectorAll('ul.product-grid > li'));
          var nextMore = doc.querySelector('[data-als-col-more]');
          var added = incoming.map(function (li) {
            var node = document.importNode(li, true);
            grid.appendChild(node);
            return node;
          });
          prepareCards(grid, added);

          var shown = nextMore ? nextMore.dataset.shown : String(grid.children.length);
          var total = more.dataset.total;
          more.dataset.shown = shown;
          more.dataset.next = (nextMore && nextMore.dataset.next) || '';
          var shownEl = more.querySelector('[data-als-shown]');
          if (shownEl) shownEl.textContent = shown;
          var bar = more.querySelector('.als-col-more__bar span');
          if (bar) bar.style.setProperty('--p', Math.min(100, Math.round((shown / total) * 100)) + '%');
          btn.removeAttribute('aria-busy');
          if (!more.dataset.next) btn.remove();

          if (fromKeyboard && added[0]) {
            var link = added[0].querySelector('a[href]');
            if (link) link.focus({ preventScroll: false });
          }
        })
        .catch(function () {
          // Fall back to normal pagination
          btn.removeAttribute('aria-busy');
          window.location.href = next;
        });
    });
  }

  /* ── Boot / re-boot after Shopify filter re-renders ─────────────────── */

  function initGrid(section) {
    // Collections: #product-grid is the <ul>; search: it wraps the <ul>
    var grid = section.querySelector('ul.product-grid');
    if (grid) {
      prepareCards(grid, Array.prototype.slice.call(grid.children));
    }
    initMore(section);
  }

  function init() {
    var section = document.querySelector('[data-als-col]');
    initHeader();
    if (!section) return;
    initDiscover(section);
    initGrid(section);
    if (!REDUCED) document.documentElement.classList.add('als-col-motion');

    var container = document.getElementById('ProductGridContainer');
    if (container && !container.dataset.alsWatch) {
      container.dataset.alsWatch = 'true';
      new MutationObserver(function () {
        initGrid(section);
      }).observe(container, { childList: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
